module.exports = __webpack_public_path__ + "static/img/mediaplanning2.6215466b.png";